import { Controller } from '@hotwired/stimulus';

// Persists dismissal of one-off UI hints as a single hashmap in localStorage,
// so adding a new dismissible hint elsewhere never needs its own storage key:
// data: { controller: "dismissible-hint", dismissible_hint_key_value: "some_hint" }
const STORAGE_KEY = 'dismissedHints';

function readDismissedHints() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export default class extends Controller {
  static values = { key: String };

  connect() {
    if (readDismissedHints()[this.keyValue]) this.element.remove();
  }

  dismiss() {
    const hints = readDismissedHints();
    hints[this.keyValue] = true;
    // Always remove the hint even if localStorage is unavailable (private
    // browsing, quota exceeded) - it just won't stay dismissed next visit.
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(hints));
    } catch {}
    this.element.remove();
  }

  // Hides the hint for this page view only, e.g. once its advice no longer applies -
  // unlike dismiss(), this does not persist, so the hint can reappear later.
  hide() {
    this.element.remove();
  }
}
